import FirstChoiceItem from 'components/ItemSubstitution/FirstChoiceItem/FirstChoiceItem';

export default FirstChoiceItem;
